import AttributeMultiSelect from './attributeMultiSelect.container';

export default AttributeMultiSelect